// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const GanttChartIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="GanttChartIcon" ref={forwardedRef} {...props}>
      <path d="M3 3h1.5v6.5h8.936V11H4.5v4.5H17V17H4a1 1 0 0 1-1-1z" />
      <path d="M15.482 5H9V3.5h6.482z" />
      <path d="M7 6.5V8h4V6.5z" />
      <path d="M11 14h6v-1.5h-6z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const GanttChartIcon = /* @__PURE__ */ Object.assign(
  GanttChartIconComponent,
  { displayName: 'GanttChartIcon' },
);
